import React, { useState, useEffect } from 'react';
import { ContentBox } from "../ContentBox"
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput, SingleRedio, SingleSelect, SingleText } from '../../Res/BaseInput';
import { SubmitButton } from '../../Res/BaseButton';
import Swal from 'sweetalert2';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { getUserInfoCompanyId } from '../../../Login/Auth';
import { checkNum } from '../../../../item/ItemTools';
import { api_getDepartmentList, api_getRoleList } from '../../../../api/apiCompany';
import { api_checkEmployeeResume, api_addEmployeeResume } from '../../../../api/apiEmployeeResume';
import { ReqEmployeeResumeCheck, ReqEmployeeResumeAdd, RespEmployeeResumeOtherDataBase } from '../../../../item/ItemEmployeeResume';

export function EmployeeResumeAdd({ setIsLoading }) {
    const [companyId] = useState(getUserInfoCompanyId())
    const [accountId, setAccountId] = useState("")
    const [idNumber, setIdNumber] = useState("")
    const [mobile, setMobile] = useState("")
    const [employeeId, setEmployeeId] = useState("")
    const [nickName, setNickName] = useState("")
    const [sex, setSex] = useState("")
    const [enrollDate, setEnrollDate] = useState(moment(new Date()).format('YYYY-MM-DD'))
    const [departmentId, setDepartmentId] = useState("")
    const [roleId, setRoleId] = useState("")

    const [departmentList, setDepartmentList] = useState([])
    const [roleList, setRoleList] = useState([])

    const [dateError, setDateError] = useState(false)
    const [isCheck, setIsCheck] = useState(false)
    const [isAdd, setIsAdd] = useState(false)


    useEffect(() => {
        //getDepartmentList()
        console.log(companyId)
    }, [])

    useEffect(() => {
        if (departmentId !== "")
            getRoleList()
    }, [departmentId])

    function getDepartmentList() {
        setIsLoading(true)
        api_getDepartmentList({
            companyId,
            success: (jsonData) => {
                console.log(jsonData)
                setDepartmentList(jsonData.list)
                // if(jsonData.list.length > 0)
                //     setDepartmentId(jsonData.list[0].departmentId)
                setIsLoading(false)
            },
            failure: (err) => {
                setIsLoading(false)
            }
        })
    }

    function getRoleList() {
        setIsLoading(true)
        api_getRoleList({
            departmentId,
            success: (jsonData) => {
                console.log(jsonData)
                setRoleList(jsonData.list)
                setIsLoading(false)
            },
            failure: (err) => {
                setIsLoading(false)
            }
        })
    }

    function toCheck() {
        if (mobile === "") {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: "手機號不得為空",
            })
            return
        }

        if (!checkNum(mobile)) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: "手機格式不正確",
            })
            return
        }

        setIsLoading(true)
        var mReqEmployeeResumeCheck = new ReqEmployeeResumeCheck({ mobile, companyId })
        console.log(mReqEmployeeResumeCheck)
        api_checkEmployeeResume({
            mReqEmployeeResumeCheck,
            success: (jsonData) => {
                console.log(jsonData)
                setIsLoading(false)
                switch (jsonData.action) {
                    case "add":
                        setIsCheck(true);
                        setIsAdd(true);
                        getDepartmentList()
                        break;
                    case "edit":
                        setIsCheck(true);
                        setAccountId(jsonData.info.accountId)
                        getDepartmentList()
                        break;
                    case "change":
                        Swal.fire({
                            type: 'success',
                            title: '提醒',
                            text: "此帳號已是員工，請利用“變更職務”的方式",
                        })
                        break;
                    default:
                        break;
                }
            },
            failure: (err) => {
                //console.log(err)
                setIsLoading(false)
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message,
                })
            }
        })

    }

    function toAdd() {
        if (dateError) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: "日期格式有誤, 請檢查",
            })
            return
        }

        var errorMessageArray = []
        if (idNumber === "")
            errorMessageArray.push("身分證號碼")
        if (nickName === "")
            errorMessageArray.push("姓名")
        if (sex === "")
            errorMessageArray.push("性別")
        if (departmentId === "")
            errorMessageArray.push("部門")
        if (roleId === "")
            errorMessageArray.push("職稱")

        if (errorMessageArray.length > 0) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: errorMessageArray.join(", ") + "不得為空",
            })
            return
        }

        var mRespEmployeeResumeOtherDataBase = new RespEmployeeResumeOtherDataBase({
            mobile,
            idNumber,
            employeeId,
            name: nickName,
            sex,
            enrollDate
        })
        var mReqEmployeeResumeAdd = new ReqEmployeeResumeAdd({
            companyId,
            accountId,
            idNumber,
            mobile,
            nickName,
            departmentId,
            roleId,
            base: JSON.stringify(mRespEmployeeResumeOtherDataBase),
            isAdd
        })
        api_addEmployeeResume({
            mReqEmployeeResumeAdd,
            success: (jsonData) => {
                //console.log(jsonData)
                setIsLoading(false)
                //console.log(jsonData.tokenId)
                window.location.assign("/EmployeeResumeEdit/" + jsonData.tokenId);
            },
            failure: (err) => {
                //console.log(err.message)
                setIsLoading(false)
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message,
                })
            }
        })
    }



    const onChange = (jsDate, dateString) => {
        //console.log(jsDate)
        //console.log(dateString)
        if (dateString === "Invalid date") {
            setDateError(true)
        } else {
            setDateError(false)
            setEnrollDate(dateString)
        }
    }


    var baseTitle = "員工基本資訊及職務"
    var baseContent =
        <>
            <div className="row">
                <div className="col-md-12">
                    {isCheck ?
                        <SingleText title={"手機號碼-登入帳號"} val={mobile} size={4} />
                        :
                        <SingleInput title={"手機號碼-登入帳號"} val={mobile} action={setMobile} placeholder={"0988123456"} size={4} />
                    }
                </div>
                {isCheck ? <></> :
                    <SubmitButton action={toCheck} name="確定" isRight={true} />
                }
            </div>
            {isCheck ?
                <>
                    <div class="hr-line-dashed"></div>
                    <div className="row">
                        <div className="col-md-12">
                            <SingleInput title={"身分證號碼"} val={idNumber} action={setIdNumber} placeholder={"A123456789"} size={4} />
                            <SingleInput title={"員工編號"} val={employeeId} action={setEmployeeId} placeholder={"自行定義"} size={4} />
                        </div>
                    </div>

                    <div class="hr-line-dashed"></div>

                    <div class="row">
                        <div class="col-md-12">
                            <SingleInput title={"姓名"} val={nickName} action={setNickName} placeholder={"王大同"} size={4} />
                            <SingleRedio title={"性別"} arr={[{ "val": 1, "name": "男" }, { "val": 2, "name": "女" }]} val={sex} action={setSex} size={4} />

                            <div class="col-md-4">
                                <p>報到日期-起薪日</p>
                                <DatePickerInput
                                    displayFormat='YYYY/MM/DD'
                                    returnFormat='YYYY-MM-DD'
                                    onChange={onChange}
                                    value={enrollDate}
                                    className='my-react-component'
                                />
                            </div>
                        </div>
                    </div>

                    <div class="hr-line-dashed"></div>

                    <div class="row">
                        <div class="col-md-12">
                            <SingleSelect
                                title={"部門"}
                                attr={departmentList}
                                val={departmentId}
                                v={'departmentId'}
                                n={'departmentName'}
                                action={setDepartmentId}
                                size={4}
                                hasBlank={true}
                            />
                            <SingleSelect
                                title={"職稱"}
                                attr={roleList}
                                val={roleId}
                                v={'roleId'}
                                n={'roleName'}
                                action={setRoleId}
                                size={4}
                                hasBlank={true}
                            />

                        </div>
                        <SubmitButton action={toAdd} name="確定" isRight={true} />
                    </div>
                </> : <></>
            }
        </>


    return (
        <>
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} titleSize={6} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}